import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

const HeroSlider = () => {
  const swiperRef = useRef<Swiper | null>(null);

  useEffect(() => {
    swiperRef.current = new Swiper('.hero-swiper', {
      modules: [Autoplay, EffectFade],
      effect: 'fade',
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 1500,
    });

    return () => {
      if (swiperRef.current) {
        swiperRef.current.destroy();
      }
    };
  }, []);

  const slides = [
    {
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/d9b9da84710e933b8ef9ee9795d53b45.jpeg',
      alt: '印刷サービスのイメージ1',
    },
    {
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/0e9c11603edb00253f6bd6be55dfab2d.jpeg',
      alt: '印刷サービスのイメージ2',
    },
    {
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/61626ee2d537514ac3ad27edc3c4c496.jpeg',
      alt: '印刷サービスのイメージ3',
    },
  ];

  return (
    <section className="relative h-screen min-h-[600px] overflow-hidden">
      <div className="hero-swiper w-full h-full">
        <div className="swiper-wrapper">
          {slides.map((slide, index) => (
            <div key={index} className="swiper-slide">
              <div className="relative w-full h-full">
                <img
                  src={slide.image}
                  alt={slide.alt}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute inset-0 flex items-center justify-center z-10">
        <div className="w-full px-4 md:px-8 lg:px-16">
          <div className="max-w-2xl text-left">
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              想いを、カタチに。
            </h2>
            <p className="text-primary text-xl md:text-2xl lg:text-3xl font-medium mb-12">
              岡山市で40年、お客様ひとりひとりの<br className="hidden md:block" />
              大切な記念を印刷でお手伝いします
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-start gap-4 md:gap-6">
              <a
                href="tel:086-012-3456"
                className="w-full sm:w-auto px-8 py-4 bg-white text-primary border-2 border-primary rounded-full font-bold text-base md:text-lg hover:bg-primary hover:text-white transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                お電話でのご相談
              </a>
              <Link
                to="/contact"
                className="w-full sm:w-auto px-8 py-4 bg-primary text-white rounded-full font-bold text-base md:text-lg hover:bg-primary-dark transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap"
              >
                <i className="ri-mail-line text-xl"></i>
                お問い合わせフォーム
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSlider;
